import type { RouteRecordRaw } from "vue-router"
import { injectRouteList } from "@/hooks/useRouter"
import { ORDER_ACTION_PERMISSIONS } from "@/utils/roleFeatureAccess"

const Layout = () => import("@/layout/index.vue")
const OrderIndex = () => import("@/views/page/order/OrderIndexV2.vue")

const ORDER_HIDDEN_ROLE_PROFILES = ["finance"]

const firstOrderLevelRoute: RouteRecordRaw[] = [
  {
    path: "/order/order",
    redirect: "/order/order/index",
    meta: {
      title: "营业订单",
      hidden: true,
      permissions: ORDER_ACTION_PERMISSIONS.viewOrders,
      hiddenRoleProfiles: ORDER_HIDDEN_ROLE_PROFILES,
    },
    children: [
      {
        path: "/order/order/index",
        component: OrderIndex,
        name: "OrderIndex",
        meta: {
          title: "营业订单",
          activeMenu: "/order",
          permissions: ORDER_ACTION_PERMISSIONS.viewOrders,
          hiddenRoleProfiles: ORDER_HIDDEN_ROLE_PROFILES,
        },
      },
    ],
  },
]
const order: RouteRecordRaw[] = [
  {
    path: "/order",
    component: Layout,
    redirect: "/order/order/index",
    children: injectRouteList(firstOrderLevelRoute),
    meta: {
      order: 2,
      title: "订单",
      showTag: false,
      svgIcon: "nav-order",
      permissions: ORDER_ACTION_PERMISSIONS.viewOrders,
      hiddenRoleProfiles: ORDER_HIDDEN_ROLE_PROFILES,
    },
  },
]
export default order
